import { TeamWidget } from './component';


export default TeamWidget;
